// User ID for the Meritic super-admin account.
// This user gets access to internal-only features (Eva, Charts tab, etc.).
export const SUPERADMIN_USER_ID = "02c73738-9481-4d0f-85c4-e927c6a09d09";
